import {NavbarMainComponent} from "../components/body/navbar.component";
import {ProductCardComponent} from "../components/products.component";
import {AboutComponent, ClientComponent, ContactComponent, InformationComponent} from "../components/about.component";
import {FooterComponent} from "../components/body/footer.component";
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {
    CategoryMiniSidebar,
    CategorySidebar,
    ModelsMiniSidebar,
    ModelsSidebar
} from "../components/body/sidebar.component";
import React, {useEffect, useState} from "react";
import apiJson from "../helper/axios";
import {CatalogSEO} from "../helper/seo";
import HelpPopup from "../components/HelperPopUp.component";

const showProducts = [
    {
        "id" : 1,
        "value" : 20,
    },
    {
        "id" : 2,
        "value" : 40,
    },
    {
        "id" : 3,
        "value" : 60,
    },
]


function Catalog() {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const location = useLocation();

    const [querySearch, setQuerySearch] = useState("");
    const [queryCategory, setQueryCategory] = useState("");
    const [queryModel, setQueryModel] = useState("");
    const [querySort, setQuerySort] = useState("");
    const [queryShow, setQueryShow] = useState("");

    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]); // For filtered products

    const getDataCategories = async () => {
        try {
            const response = await apiJson.get("/categories/xray");
            setCategories(response?.data?.data?.categories || []);
        } catch (error) {
            console.error("Error fetching categories:", error.message);
        }
    };

    const getDataProducts = async () => {
        try {
            const response = await apiJson.get("/product/metal_detector", {
                params: {
                    show: queryShow,
                },
            });
            const fetchedProducts = response?.data?.data?.product?.data || [];
            setProducts(fetchedProducts);
            localStorage.setItem("products", JSON.stringify(fetchedProducts));
        } catch (error) {
            console.error("Error fetching products:", error.message);
        }
    };

    useEffect(() => {
        getDataProducts();
        getDataCategories();
    }, [queryShow, queryModel]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryShow(params.get("show") || "");
        setQuerySearch(params.get("search") || "");
        setQueryCategory(params.get("category") || "");
        setQueryModel(params.get("model") || "");
        setQuerySort(params.get("sort") || "");
    }, [location]);

    const handleCategoryChange = (e) => {
        const category = e;
        const query = new URLSearchParams(searchParams);
        query.set("category", category);
        navigate(`?${query.toString()}`);
    };

    const handleCategoryMiniChange = (e) => {
        const category = e.target.value;
        const query = new URLSearchParams(searchParams);
        query.set("category", category);
        navigate(`?${query.toString()}`);
    };

    const handleModelChange = (e) => {
        const model = e
        const query = new URLSearchParams(searchParams);
        query.set("model", model);
        navigate(`?${query.toString()}`);
    };

    const handleModelMiniChange = (e) => {
        const model = e.target.value; // Get the selected value
        const query = new URLSearchParams(searchParams);
        query.set("model", model);
        navigate(`?${query.toString()}`);
    };


    const handleSortOrderChange = (e) => {
        const sortOrder = e.target.value;
        const query = new URLSearchParams(searchParams);
        query.set("sort", sortOrder);
        navigate(`?${query.toString()}`);
    };

    const filterProducts = () => {
        let allProducts = localStorage.getItem("products");
        if (allProducts?.length !== 0) {
            allProducts = JSON.parse(allProducts);

            let filtered = [...allProducts];

            if (queryCategory) {
                filtered = filtered.filter(
                    (product) => product?.category?.slug === queryCategory
                );
            }

            // Filter by model
            if (queryModel) {
                filtered = filtered.filter(
                    (product) => product?.model?.slug === queryModel
                );
            }

            if (querySearch) {
                const lowerQueryName = querySearch.toLowerCase();
                filtered = filtered.filter(
                    (product) =>
                        product?.name?.toLowerCase().includes(lowerQueryName) ||
                        product?.model?.name?.toLowerCase().includes(lowerQueryName) ||
                        product?.category?.name?.toLowerCase().includes(lowerQueryName)
                );
            }

            if (querySort === "asc") {
                filtered.sort((a, b) => a.name.localeCompare(b.name));
            } else if (querySort === "desc") {
                filtered.sort((a, b) => b.name.localeCompare(a.name));
            }

            setFilteredProducts(filtered);
        }
    };

    useEffect(() => {
        filterProducts();
    }, [querySearch, queryCategory, querySort, products]);


    return(
        <>
            <CatalogSEO />
            <NavbarMainComponent />
            <div className={"mt-28 md:mt-28"} >
                <div className={"pt-7 md:pt-10 mb-20"}>
                    <div style={{maxWidth:"1500px"}} className={"w-11/12 mx-auto"}>
                        <div className={"flex pb-3 justify-between"}>
                            <div className={"my-auto"}>
                                <h1 className={"text-2xl md:text-3xl text-gray-800 font-semibold"}>{querySearch ? querySearch : 'Produk Katalog'}</h1>
                            </div>
                            <div className={"my-auto pt-2"}>
                                <ul className={"flex my-auto gap-3"}>
                                    <li className={"my-auto text-sm text-gray-500"}>
                                        <Link to={"/"}>
                                            <p className={"my-auto font-light hover:text-blue-950"}>Beranda</p>
                                        </Link>
                                    </li>
                                    <li className={"my-auto text-sm "}>
                                        <Link to={"/catalog"}>
                                            <p className={"my-auto font-semibold text-main"}>{'Katalog'}</p>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={"border-y w-full my-3 border-gray-300"}>
                            <div className={"md:pt-2.5 pb-1 pt-3 block md:flex justify-between"}>
                                <div className={"w-full hidden md:block"}>
                                    <ul className={"flex"}>
                                        <li className={"border-r my-auto  px-4 border-gray-300"}>
                                            <div className={"my-auto"}>
                                                <div className={"my-auto text-sm"}>
                                                    <p className={"text-gray-600 my-auto font-semibold"}>1-24 of 36</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className={"px-3 flex text-sm "}>
                                            <div className={"my-auto"}>
                                                <p className={"text-gray-600 font-light my-auto"}>Tampilkan Data  :</p>
                                            </div>
                                            <div className={"px-3"}>

                                                <ul className={"flex gap-3"}>
                                                    {showProducts?.map((item ,index) => {
                                                        return(
                                                            <li className={""} key={index}>
                                                                <ListShowCatalog
                                                                    value={item?.value}
                                                                    navigate={navigate}
                                                                    searchParams={window.location.search}
                                                                />
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                            <div className={"my-auto"}>
                                                <p className={"text-gray-600 text-sm font-light my-auto"}>per halaman</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className={"text-sm"}>
                                    <div className={"flex scrollbar-hide overflow-x-auto gap-3"}>
                                        <div className={"flex  gap-3"}>
                                            <div className={"pt-1"}>
                                                <p className={"text-gray-600 font-light my-auto"}>Urutkan</p>
                                            </div>
                                            <ul className={"flex gap-2  py-2 md:pt-2"}>
                                                <li className="border-l -mt-1.5 border-gray-300">
                                                    <select
                                                        className="px-5 py-0.5 my-auto cursor-pointer"
                                                        onChange={handleSortOrderChange}
                                                    >
                                                        <option value="" disabled>
                                                            Select sort order
                                                        </option>
                                                        <option
                                                            value="new"
                                                            className="text-gray-700 my-auto text-sm font-semibold"
                                                        >
                                                            Terbaru
                                                        </option>
                                                        <option
                                                            value="asc"
                                                            className="text-gray-800 my-auto text-sm font-semibold"
                                                        >
                                                            Awal
                                                        </option>
                                                    </select>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className={"md:hidden block"}>
                                            <CategoryMiniSidebar handleCategoryChange={handleCategoryMiniChange}  />
                                        </div>
                                        <div className={"md:hidden block"}>
                                            <ModelsMiniSidebar handleModelChange={handleModelMiniChange}  />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{maxWidth:"1500px"}} className={"w-full sm:w-11/12 mx-auto"}>
                                <div className={"block md:flex justify-between"}>
                                    <div className={"w-full hidden md:block md:w-4/12 lg:w-3/12 "}>
                                        <div className={"mb-1"}>
                                            <CategorySidebar handleCategoryChange={handleCategoryChange} selectedValue={queryCategory} />
                                        </div>
                                        <div className={"mb-1"}>
                                            <ModelsSidebar handleModelChange={handleModelChange} selectedValue={queryModel}/>
                                        </div>
                                    </div>
                                    <div className={"w-full md:w-8/12 lg:w-9/12"}>
                                        <div className={"py-10 md:py-0"}>
                                            <div className={"w-full max:w-11/12 mx-auto"}>
                                                {filteredProducts?.length === 0 ? (
                                                    <div className={"pt-10 pb-10  w-full"}>
                                                        <div className={"w-11/12 py-20 border-b-none md:border-b border-gray-300 text-center mx-auto"}>
                                                            <div className={" "}>
                                                                <div className={"my-4"}>
                                                                    <h1 className={"text-5xl font-semibold text-gray-600"}>
                                                                        (;-;)
                                                                    </h1>
                                                                </div>
                                                            </div>
                                                            <div className={""}>
                                                                <h1 className={"text-lg font-light text-gray-700"}>Search Not Found</h1>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ):(
                                                    <ul className={"w-full flex flex-wrap "}>
                                                        {filteredProducts.map((item, index) => {
                                                            return(
                                                                <>
                                                                    <li key={index} className={"w-6/12 md:w-6/12 lg:w-4/12"}>
                                                                        <div className={""}>
                                                                            <ProductCardComponent name={item?.name} category={item?.category?.name} slug={item?.slug} model={item?.model?.name} type={item?.type} brochure={item?.brochure} image={item?.main_image}  />
                                                                        </div>
                                                                    </li>
                                                                </>
                                                            )
                                                        })}
                                                    </ul>

                                                )}
                                            </div>
                                        </div>
                                    </div>
                    </div>

                    </div>
                </div>
                <AboutComponent />
                <InformationComponent />
                <ClientComponent />
            </div>
            {/*<ContactComponent />*/}
            <FooterComponent />
            <HelpPopup />
        </>
    )
}






export const ListShowCatalog = ({ value, navigate, searchParams }) => {
    const onChangeShowPage = (category) => {
        const query = new URLSearchParams(searchParams);
        query.set("show", category);
        navigate(`?${query.toString()}`);
    };

    return (
        <>

            <button
                onClick={() => onChangeShowPage(value)}
                className="hover:bg-blue-900 cursor-pointer bg-gray-100  text-gray-500  hover:text-white py-1 px-2 rounded-xs"
            >
                <p className=" font-medium">{value}</p>
            </button>
        </>
    );
};

export default Catalog;